module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens7-054f3850d1dbe3ec5855663d944ac2ff.jpg";